import React, { useEffect, useMemo, useRef, useState } from "react";
import "./PerformanceDashboard.css";
import Menubar from "../Menubar";
import { store } from "../../App";
import * as Yup from "yup";
import KpiService from "../../Services/KpiService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { GrDocumentPdf } from "react-icons/gr";
import { FaFileExcel } from "react-icons/fa";
import { useFormik } from "formik";
import { downloadUrl } from "../../Services/Configuration";
import { FaDownload } from "react-icons/fa";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Modal,Container, Row, Col, Table,Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const DistrictIndicatorwiseperformanceMonitoringReport = () => {
    const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
    const printRef = useRef();
    const [printData, setPrintData] = useState(null);
    const [printScoreObj, setPrintScoreObj] = useState(null);
    const [showTable, setShowTable] = useState(false);
    const [selectedFileData, setSelectedFileData] = useState({});
    const [reportData, setReportData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupData, setPopupData] = useState([]);
    const [popupSearchText, setPopupSearchText] = useState("");
    const popupPrintRef = useRef();
    const [searchText, setSearchText] = useState("");








 
    const [scoresData, setScoresData] = useState([]);
    const [popupSearchTextData, setPopupSearchTextData] = useState("");
    let username = localStorage.getItem("username"); let districtid = localStorage.getItem("districtid");
 
    let mandalid = localStorage.getItem("mandalid");
    const [monthOptions, setMonthOptions] = useState([]);

    const validationSchema = Yup.object({});
    const formik = useFormik({
        initialValues: { category: "", year: "", month: "", type: "", criteriaRemarks: "" },
        validationSchema: validationSchema,
        onSubmit: async (values) => {  },
    });

    const scoreForMonth = formik.values.category === "month" ? (formik.values.month || "0") : (formik.values.category === "provisional" || formik.values.category === "annual") ? "3" : "0";
    const scoreCatId = formik.values.category === "month" ? "Monthly" : formik.values.category === "provisional" ? "Provisionally"
        : formik.values.category === "annual" ? "Annually" : "Monthly";
    const categoryOptions = [{ value: "month", label: "Month" }, { value: "provisional", label: "Provisional" }, { value: "annual", label: "Annual" },];

    // Handler to show area (district/mandal) breakdown for a grade on an indicator
    const handleGradeClick = (row, grade) => {
        // Use a Map keyed by stringified area id to ensure stable keys
        const areaMap = new Map();

        reportData
            .filter(item => item.cs_indicator_name === row.indicator && ((item.achieved_grade || item.grade) === grade))
            .forEach((item, idx) => {
                const rawAreaId = formik.values.type === "Mandal"
                    ? (item.mandal_id ?? item.mandal ?? item.district_id ?? item.district)
                    : (item.district_id ?? item.district ?? item.mandal_id ?? item.mandal);

                const areaId = rawAreaId !== undefined && rawAreaId !== null ? String(rawAreaId) : `unknown-${idx}`;

                // determine district and mandal names from multiple possible fields
                const districtName = item.district_name ?? item.districtName ?? item.district ?? item.name ?? null;
                const mandalName = item.mandal_name ?? item.mandalName ?? item.mandal ?? null;

                // fallback label
                const fallbackLabel = districtName || mandalName || `ID:${areaId}`;

                const scoreVal = item.capped_achieved_score ?? item.captured_achieved_score ?? item.achieved_value ?? null;
                const gradeVal = item.achieved_grade ?? item.grade ?? null;

                if (!areaMap.has(areaId)) {
                    areaMap.set(areaId, {
                        district_name: districtName || "",
                        mandal_name: mandalName || "",
                        label: fallbackLabel,
                        score: scoreVal,
                        grade: gradeVal,
                        ids: new Set(),
                    });
                } else {
                    // ensure we have a score/grade if previously blank
                    const existing = areaMap.get(areaId);
                    if ((existing.score === undefined || existing.score === "" || existing.score === null) && scoreVal !== null) existing.score = scoreVal;
                    if ((existing.grade === undefined || existing.grade === "" || existing.grade === null) && gradeVal) existing.grade = gradeVal;
                }

                const indicatorId = item.cs_indicator_id ?? item.cs_indicator_name ?? item.indicator_id ?? item.indicator;
                if (indicatorId !== undefined && indicatorId !== null) {
                    areaMap.get(areaId).ids.add(indicatorId);
                }
            });

        let popupList = Array.from(areaMap.values()).map(a => ({
            district_name: a.district_name || a.label,
            mandal_name: a.mandal_name || "",
            score: a.score ?? "-",
            grade: a.grade ?? "-",
            total: a.ids.size,
        }));

        // sort by numeric score descending; non-numeric scores go to the bottom
        popupList.sort((x, y) => {
            const nx = Number(x.score);
            const ny = Number(y.score);
            const vx = Number.isFinite(nx) ? nx : -Infinity;
            const vy = Number.isFinite(ny) ? ny : -Infinity;
            if (vy === vx) return (x.district_name || "").localeCompare(y.district_name || "");
            return vy - vx;
        });

        setPopupTitle(`${row.indicator} - ${grade}`);
        setPopupData(popupList);
        setShowPopup(true);
    };

    const groupedReport = useMemo(() => {
        if (!Array.isArray(reportData)) return [];

        const map = {};

        reportData.forEach(item => {
            const name = item.cs_indicator_name;
            const grade = item.achieved_grade || item.grade || null;
            const type = item.indicator_type || item.indicatorType || "";

            const areaId = formik.values.type === "Mandal" ? (item.mandal_id || item.mandal ) : (item.district_id || item.district);

            if (!map[name]) {
                map[name] = { indicator_type: type, "A+": new Set(), A: new Set(), B: new Set(), C: new Set() };
            } else if (!map[name].indicator_type && type) {
                map[name].indicator_type = type;
            }

            const gradeKey = grade || "C";

            if (!map[name][gradeKey]) {
                map[name][gradeKey] = new Set();
            }

            if (areaId !== undefined && areaId !== null) {
                map[name][gradeKey].add(areaId);
            }
        });

        return Object.keys(map).map(name => {
            const groups = map[name];
            const total = new Set([
                ...groups["A+"],
                ...groups.A,
                ...groups.B,
                ...groups.C
            ]).size;

            return {
                indicator: name,
                indicator_type: groups.indicator_type ,
                "A+": groups["A+"].size,
                A: groups.A.size,
                B: groups.B.size,
                C: groups.C.size,
                total
            };
        });

    }, [reportData, formik.values.type]);

  const getRingColor = (score) => { if (score >= 90) return "#6cc04a"; if (score >= 75) return "#f7c600"; if (score >= 50) return "#2fb4ff"; return "#ff5a5a"; };

  
 const renderStatusRing = (score, maxScore = 100, size = 40, strokeWidth = 6) => {
    const parsedScore = Number(score) || 0; const radius = (size - strokeWidth) / 2; const circumference = 2 * Math.PI * radius;
    const progress = (Math.min(parsedScore, maxScore) / maxScore) * circumference; const ringColor = getRingColor(parsedScore);

    return (
        <svg width={size} height={size}>
            {/* Background Circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke="#e6e6e6"
                strokeWidth={strokeWidth}
            />

            {/* Progress Circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={ringColor}
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={circumference - progress}
                strokeLinecap="round"
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />

            <text
                x="50%"
                y="50%"
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize="10"
                fontWeight="bold"
            >
                {parsedScore}
            </text>
        </svg>



    );
};


    const displayedGroupedReport = useMemo(() => {
        if (!searchText || String(searchText).trim() === "") return groupedReport;
        const s = String(searchText).trim().toLowerCase();

        const fields = ["indicator", "indicator_type", "A+", "A", "B", "C", "total"];

        return groupedReport.filter(r => {
            return fields.some(f => {
                const val = r[f];
                if (val === null || val === undefined) return false;
                return String(val).toLowerCase().includes(s);
            });
        });
    }, [groupedReport, searchText]);

    const sanitizeFileName = (name = "report") => {
        return String(name).replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_+/g, "_");
    };

      const handleDownloadReport = async () => {
    try {
        const input = printRef.current;
        if (!input) return;
        // Save original styles
        const oldHeight = input.style.maxHeight;
        const oldOverflow = input.style.overflowY;
        // Expand entire table
        input.style.maxHeight = "none";
        input.style.overflowY = "visible";
        const html2pdf = (await import("html2pdf.js")).default;
        await html2pdf()
            .set({
                margin: 5,
                filename: `${sanitizeFileName(reportTitle)}.pdf`,
                image: { type: "jpeg", quality: 1 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    scrollY: 0,
                    windowHeight: input.scrollHeight
                },
                jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "landscape"
                },
                pagebreak: {
                    mode: ["css", "legacy", "avoid-all"]
                }
            })
            .from(input)
            .save();
 
        // Restore scroll
        input.style.maxHeight = oldHeight;
        input.style.overflowY = oldOverflow;
 
    } catch (err) {
        console.error(err);
    }
};
    const handleExportExcel = async () => {
        try {
            const rows = (displayedGroupedReport || []).map((it, idx) => ({
                  SNo: idx + 1,
                Indicator: it.indicator || "",
                IndicatorType: it.indicator_type || "",
                "Achiever (A+) (Score ≥ 90)": it["A+"] ?? 0,
                "Front Runner (A) (Score ≥ 75)": it.A ?? 0,
                "Performer (B) (Score ≥ 50)": it.B ?? 0,
                "Aspirant (C) (Score < 50)": it.C ?? 0,
                Total: it.total ?? 0,
            }));

            const fileBase = sanitizeFileName((reportTitle || "Indicator_Report").slice(0, 80)); const fileName = `${fileBase}_${new Date().toISOString().slice(0,10)}.xlsx`;

            try {
                const XLSX = await import("xlsx"); const wb = XLSX.utils.book_new(); const ws = XLSX.utils.json_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, "Indicators"); XLSX.writeFile(wb, fileName); return;
            } catch (e) { console.warn("xlsx not available, falling back to CSV", e); }

            // CSV fallback
            if (rows.length === 0) return showAlertMessage("No data to export", "warning");
            const keys = Object.keys(rows[0]);
            const csv = [keys.join(",")].concat(rows.map(r => keys.map(k => `"${String(r[k] ?? "").replace(/"/g, '""') }"`).join(","))).join("\n");
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" }); const url = URL.createObjectURL(blob); const a = document.createElement("a");
            a.href = url; a.download = fileName.replace(/xlsx$/, "csv"); document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
        } catch (err) { console.error(err); showAlertMessage("Export failed", "error"); }
    };

    const displayedPopupData = useMemo(() => {
        if (!popupSearchText || String(popupSearchText).trim() === "") return popupData || [];
        const s = String(popupSearchText).trim().toLowerCase();

        const fields = ["district_name", "mandal_name", "score", "grade", "total"];

        return (popupData || []).filter(p => {
            return fields.some(f => { const val = p?.[f]; if (val === null || val === undefined) return false; return String(val).toLowerCase().includes(s); }); });
    }, [popupData, popupSearchText]);

    const handleExportPopupExcel = async () => {
        try {
            const rows = (displayedPopupData || []).map((it, idx) => ({
                SNo: idx + 1, District: it.district_name || "", Mandal: it.mandal_name || "", Score: it.score ?? "", Grade: it.grade ?? "", TotalIndicators: it.total ?? "",
            }));

            const fileBase = sanitizeFileName((popupTitle || "Popup_Report").slice(0, 80)); const fileName = `${fileBase}_${new Date().toISOString().slice(0,10)}.xlsx`;

            try {
                const XLSX = await import("xlsx"); const wb = XLSX.utils.book_new(); const ws = XLSX.utils.json_to_sheet(rows); XLSX.utils.book_append_sheet(wb, ws, "Details"); XLSX.writeFile(wb, fileName); return;
            } catch (e) { console.warn("xlsx not available, falling back to CSV", e); }

            if (rows.length === 0) return showAlertMessage("No data to export", "warning"); const keys = Object.keys(rows[0]);
            const csv = [keys.join(",")].concat(rows.map(r => keys.map(k => `"${String(r[k] ?? "").replace(/"/g, '""') }"`).join(","))).join("\n");
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" }); const url = URL.createObjectURL(blob); const a = document.createElement("a");
            a.href = url; a.download = fileName.replace(/xlsx$/, "csv"); document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
        } catch (err) { console.error(err); showAlertMessage("Export failed", "error"); }
    };

    const handleExportPopupPdf = async () => {
        try {
            const input = popupPrintRef.current;
            if (!input) return showAlertMessage("Nothing to print", "warning");
            // Use jsPDF + autoTable to export popup table (captures full table)
            const fileBase = sanitizeFileName((popupTitle || "Popup_Report").slice(0, 120));
            generatePdff('#popup-table', fileBase, 4, popupTitle);
        } catch (err) {
            console.error(err);
            showAlertMessage("Failed to generate PDF", "error");
        }
    };


    const selectedYear = formik?.values?.year || "";
    const scoreObj = scoresData.find( (d) => String(d.district_id) === String(districtid) && String(d.mandal_id) === String(mandalid) ) || {};
    const displayScoreObj = printScoreObj || scoreObj;
    const monthLabel = monthOptions.find((m) => String(m.value) === String(displayScoreObj?.score_for_month))?.label || (displayScoreObj?.score_for_month ? monthOptions[displayScoreObj.score_for_month - 1]?.label : "") || "";

   const fetchMonths = async () => {
        try {
            const params = { userId: username, year: formik.values.year, type: "CRITERISDASHBOARD", };
            const response = await KpiService.monthNameFromMonthCode(params);
            if (response?.data?.SCODE === "01" && response.data.dataList) {
                const months = response.data.dataList.map((month) => ({
                    value: month.month_code, label: month.month_name,
                }));
                setMonthOptions(months);
                const maxMonth = months.length
                    ? [...months].sort(
                        (a, b) => Number(b.value) - Number(a.value)
                    )[0]?.value?.toString() || ""
                    : "";

                formik.setFieldValue("month", maxMonth);
                // const firstMonth = months?.[0]?.value?.toString() || ""; formik.setFieldValue("month", firstMonth);
            } else { setMonthOptions([]); }
        } catch (error) { console.error("Error fetching months:", error); setMonthOptions([]); }
    };

     useEffect(() => { if (formik.values.year) { fetchMonths(); } else { setMonthOptions([]); formik.setFieldValue("month", ""); } }, [formik.values.year]);
    
        useEffect(() => {
            if (monthOptions.length > 0) {
                const firstMonth = monthOptions[0].value;
                if (!formik.values.month) { formik.setFieldValue("month", firstMonth); }
                if ( formik.values.category && formik.values.year && (formik.values.category !== "month" || firstMonth)) {
                    return;
                }
                else { showAlertMessage("Please select all required fields", "warning"); }
            }
        }, [monthOptions]);
  
const loadInitialReport = async () => {
    try {
        store.dispatch({ type: "SHOW_SPINNER" });

        const params = {
            userId: username,
            year: formik.values.year,
          "type": formik.values.type === "Dist" ? "Dist" : "Mandal",
            scoreCatId,
            scoreForMonth
        };

        const res = await KpiService.indicatorPerformanceMonitoringReport(params);

        if (res?.data?.SCODE === "01") {
            setReportData(res.data.dataList || []);
            setShowTable(true);
        } 
        else if (res?.data?.SCODE === "02") {
            setReportData([]);
            setShowTable(false);
            showAlertMessage(res.data.SDESC, "warning");
        } 
        else {
            setReportData([]);
            setShowTable(false);
            showAlertMessage(res?.data?.SDESC || "No Data Found", "warning");
        }

    } catch (error) {
        console.error(error);
        setReportData([]);
        setShowTable(false);
        showAlertMessage("Something went wrong", "error");
    } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
    }
};

useEffect(() => {
    // Score Category and Year are mandatory
    if (!formik.values.category || !formik.values.year) {
        return;
    }

    // If Score Category is Month, wait until Month is selected
    if (formik.values.category === "month") {
        if (!formik.values.month) {
            return;
        }
    }

    // Call API
    loadInitialReport();

}, [
    formik.values.category,
    formik.values.year,
    formik.values.month,
    formik.values.type
]);

// compute table max height: show up to 20 rows before scrolling
const rowHeight = 40;
const maxVisibleRows = 15;
const tableMaxHeight = `${Math.min((reportData?.length || 0), maxVisibleRows) * rowHeight + 80}px`;

// popup table sizing: if few rows, let height be auto; otherwise cap and enable scrolling
const popupRowHeight = 40;
const popupMaxRows = 8;
const popupMaxHeight = (displayedPopupData && displayedPopupData.length > popupMaxRows)
    ? `${popupMaxRows * popupRowHeight + 80}px`
    : "auto";

// build a descriptive report title including selected filters
const typeLabel = formik.values.type === "Dist" ? "District" : formik.values.type === "Mandal" ? "Mandal" : "";
const categoryLabel = formik.values.category === "month"
    ? "Monthly"
    : (categoryOptions.find(c => c.value === formik.values.category) || {}).label || (formik.values.category || "");
const monthLabelSelected = (monthOptions.find(m => String(m.value) === String(formik.values.month)) || {}).label || (formik.values.month || "");
const reportTitle = [
    typeLabel ? `${typeLabel} Indicator wise Performance Monitoring Report` : "Indicator wise Performance Monitoring Report",
    categoryLabel ? `Score-Cat: ${categoryLabel}` : null,
    formik.values.year ? `Year: ${formik.values.year}` : null,
    formik.values.month && formik.values.category === "month" ? `Month: ${monthLabelSelected}` : null,
].filter(Boolean).join("  -  ");

    const generatePdff = ( tableId, fileName, columnsCount, title = "" ) => {
        const doc = new jsPDF("p", "pt", "a4"); let startY = 20;
        if (title) { doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.text(title, doc.internal.pageSize.getWidth() / 2, 25, { align: "center", }); startY = 40; }
        autoTable(doc, { html: tableId, startY, theme: "grid",
            styles: { fontSize: 9, halign: "center", valign: "middle", },
            headStyles: { fontStyle: "bold", },
            bodyStyles: { textColor: 0, },
            margin: { top: startY, left: 15, right: 15, },
            didDrawPage: function (data) { doc.setFontSize(10);
                doc.text( `Page ${doc.internal.getNumberOfPages()}`, doc.internal.pageSize.getWidth() - 60, doc.internal.pageSize.getHeight() - 10 );
            }, }); doc.save(`${fileName}.pdf`);
    };
    

    return (
        <>
                <div style={{ width: "100%", minHeight: "100vh", backgroundColor: "#f4f6f9", }} >

            <Menubar />
            
                <Container fluid style={{ width: "96%"}}> <div className="sa-title"> <h2>{typeLabel} Indicator wise Performance <span> Monitoring Report</span>  </h2> </div> </Container>
            
        <div
                        style={{
                            background: "#f4f6f9",
                            padding: "25px 0 60px 0",
                            minHeight: "70vh",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div style={{ width: "100%", maxWidth: "90%", padding: 12 }}>
                            <div style={{ display: "grid", alignItems: "center", marginBottom: 12 }}>
                                <div className="col-12 col-lg-12 col-md-12 col-xl-12 col-xxl-12 col-sm-12 col-xs-12">
                                    <div className="row g-2 align-items-end sdg-dash flex-nowrap">
                                        <>
                                          
                                            <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                                <label className="mb-0"> Type <span className="text-danger">*</span> </label>
                                                <select className="form-select" name="type" value={formik.values.type}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        formik.setFieldValue("type", val);
                                                        formik.setFieldValue("year", "");
                                                        formik.setFieldValue("month", "");
                                                        setShowTable(false);
                                                        setReportData([]);
                                                    }} >
                                                    <option value="">--select--</option>
                                                    <option value="Dist">District</option>
                                                    <option value="Mandal">Mandal</option>
                                                </select>
                                            </div>

                                            <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                                <label className="mb-0"> Score-Cat <span className="text-danger">*</span> </label>
                                                <select className="form-select" name="category" value={formik.values.category}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("category", e.target.value);
                                                        formik.setFieldValue("year", "");
                                                        formik.setFieldValue("month", "");
                                                        setShowTable(false);
                                                    }} >
                                                    <option value="">--select--</option>
                                                    {categoryOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}> {opt.label} </option>
                                                    ))} </select> </div>
                                            <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                                <label className="mb-0"> Year <span className="text-danger">*</span> </label>
                                                <select className="form-select" name="year" value={formik.values.year}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("year", e.target.value);
                                                        formik.setFieldValue("month", "");
                                                    }} >
                                                    <option value="">--select--</option>
                                                    <option value="2026-27">2026-27</option><option value="2025-26">2025-26</option> </select> </div>
                                            <div className="col-12 col-md-2 d-flex flex-column gap-1" style={{ visibility: formik.values.category === "month" ? "visible" : "hidden" }} >
                                                <label className="mb-0"> Month <span className="text-danger">*</span> </label>
                                                <select className="form-select" name="month" value={formik.values.month}
                                                  
                                                    onChange={(e) => {
                                                        const month = e.target.value;
        
                                                        formik.setFieldValue("month", month);
        
                                                        const type = formik.values.type;
                                                        const category = formik.values.category;
                                                        const year = formik.values.year;
        
                                                        if (!category || !year || !month) {
        
                                                            showAlertMessage("Please select all required fields", "warning");
                                                            setShowTable(false);
                                                            return;
                                                        }
        
                                                        formik.handleSubmit();
                                                    }}
                                                >
                                                    <option value="">--select--</option>
                                                    {monthOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}> {opt.label} </option>))}
                                                </select> </div> </>
                                        {showTable && (
                                         <div className="col-md-4 d-flex justify-content-end">
    <div
        style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            marginRight: "20px",   // <-- move controls a little left
            flexWrap: "nowrap"
        }}
    >
                                                    {/* <div style={{ display: "flex", alignItems: "center", background: "#f1f1f1", padding: "6px 8px", border: "1px solid #ccc" }}>
                                                        <AiOutlineSearch />
                                                    </div> */}
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        style={{ padding: 8, border: "1px solid #ccc", outline: "none", width: 200 }}
                                                    />

                                                    <OverlayTrigger
                                                        trigger={["hover", "focus", "click"]}
                                                        placement="top"
                                                        container={typeof document !== 'undefined' ? document.body : undefined}
                                                        overlay={<Tooltip id="download-tooltip">Download PDF</Tooltip>}
                                                    >
                                                        <Button variant="danger" onClick={() => handleDownloadReport()} style={{ display: "flex", alignItems: "center", padding: "6px 10px" }}>
                                                            <GrDocumentPdf />
                                                        </Button>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                        trigger={["hover", "focus", "click"]}
                                                        placement="top"
                                                        container={typeof document !== 'undefined' ? document.body : undefined}
                                                        overlay={<Tooltip id="excel-tooltip">Export Excel</Tooltip>}
                                                    >
                                                        <Button variant="success" onClick={() => handleExportExcel()} style={{ display: "flex", alignItems: "center", padding: "6px 10px" }}>
                                                            <FaFileExcel />
                                                        </Button>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        )}
                                    </div>{" "}
                                </div>
                            </div>
        
                           {showTable && (
    <>
        <div
            style={{
                marginTop: "35px",
                maxHeight: tableMaxHeight,
                overflowY: "auto",
                border: "1px solid #ddd",
            }}
            ref={printRef}
        >
            <Table
    bordered
    id="my-table"
    className="custom-table table-responsive table table-bordered sticky-table"
>
    <thead>
        <tr>
            <th colSpan={8}>{reportTitle}</th>
        </tr>
        <tr>  <th>S.No.</th>
              <th>Indicator Type </th> <th>Indicator Name </th>
        <th style={{backgroundColor:"#6cc04a"}}>Achiever (A+) <br /> (&gt;90%) </th> <th style={{backgroundColor:"#f7c600"}}>Front Runner (A) <br />(75%-89%)</th>
            <th style={{backgroundColor:"#4ecdc4"}}>Performer (B) <br />(50%-74%)</th> <th style={{backgroundColor:"#ff5a5a"}}>Aspirant (C)<br /> (&lt;50%) </th>
             <th> {formik.values.type==="Dist" ? "Total Districts" : "Total Mandals"} </th>
        </tr>
    </thead>

    <tbody>
        {displayedGroupedReport.map((row, index) => (
            <tr key={index}>
                  <td style={{ textAlign: "right" }}>{index + 1}</td> <td>{row.indicator_type}</td> <td>{row.indicator}</td>

                {Number(row["A+"] || 0) > 0 ? ( <td style={{ textAlign: "right", cursor: "pointer", color: "blue" }} onClick={() => handleGradeClick(row, "A+")} > {row["A+"]} </td> ) : ( <td style={{ textAlign: "right" }}>{row["A+"]}</td> )}

                {Number(row["A"] || 0) > 0 ? ( <td style={{ textAlign: "right", cursor: "pointer", color: "blue" }} onClick={() => handleGradeClick(row, "A")} > {row["A"]} </td> ) : ( <td style={{ textAlign: "right" }}>{row["A"]}</td> )}

                {Number(row["B"] || 0) > 0 ? ( <td style={{ textAlign: "right", cursor: "pointer", color: "blue" }} onClick={() => handleGradeClick(row, "B")} > {row["B"]} </td> ) : ( <td style={{ textAlign: "right" }}>{row["B"]}</td> )}

                {Number(row["C"] || 0) > 0 ? ( <td style={{ textAlign: "right", cursor: "pointer", color: "blue" }} onClick={() => handleGradeClick(row, "C")} > {row["C"]} </td> ) : ( <td style={{ textAlign: "right" }}>{row["C"]}</td> )}

                 <td style={{ textAlign: "right" }}> {row.total} </td>
            </tr>
        ))}
    </tbody>
</Table>
        </div>

        <Modal
            show={showPopup}
            onHide={() => setShowPopup(false)}
             size="lg"
            //  dialogClassName="side-by-side-modal" contentClassName="w-100" centered={false}
        >
           <Modal.Header closeButton>

  <Modal.Title style={{ width: "100%", textAlign: "center",fontSize:"18px" }}> {popupTitle} </Modal.Title> </Modal.Header>

           <Modal.Body className="p-2">

            <div style={{ display: "flex", width: "100%", gap: "12px" }} >
                    <div style={{ width: "100%" }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                            <input type="text" className="form-control" placeholder="Search" value={popupSearchText}
                                onChange={(e) => setPopupSearchText(e.target.value)}
                               style={{ width: "160px", height: "34px", borderRadius: "5px", flexShrink: 0 }} />
                        <div style={{ display: "flex", alignItems: "center", gap: "4px",
                                marginRight: "25px", flexShrink: 0 }} >
                            <button className="btn btn-danger btn-sm"  onClick={() => generatePdff("#popup-table", reportTitle, 6,popupTitle)}>
                                <MdOutlinePictureAsPdf />
                            </button>

                            <button className="btn btn-success btn-sm" onClick={() => handleExportPopupExcel()}>
                                <AiFillFileExcel />
                            </button>
                        </div>
                    </div>
                   
             <div className="popup-height" ref={popupPrintRef} style={{ maxHeight: popupMaxHeight, overflowY: popupMaxHeight === 'auto' ? 'visible' : 'auto' }}>
                  
                         <Table
    bordered
    hover
    id="popup-table"
    style={{
        width: "100%",
        tableLayout: "fixed"
    }}
>
                                              <thead style={{ position: "sticky", top: 0, zIndex: 100, background: "#4e835c" }} >
                                                  <tr><th colSpan={formik.values.type === "Mandal" ? 5 : 4} style={{display:"none"}}> {popupTitle} </th>
                
                                    <th style={{ textAlign: "center" }}>S.No.</th>
                                    <th style={{ textAlign: "center" }}>District</th>
                                    {formik.values.type === "Mandal" && <th style={{ textAlign: "center" }}>Mandal</th>}
                                    <th style={{ textAlign: "center" }}>Score</th>
                                    <th  style={{ textAlign: "center" }}>Grade</th>
                                </tr>
                            </thead>

                            <tbody>
                                {displayedPopupData.length > 0 ? (
                                    displayedPopupData.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: "right" }}>{index + 1}</td>
                                            <td>{item.district_name}</td>
                                            {formik.values.type === "Mandal" && <td>{item.mandal_name}</td>}
                                              <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }}> {renderStatusRing(item.score, 100, 40, 6)  }      </td>
                                            <td style={{ textAlign: "center" }}>{item.grade}</td>
                                        </tr>
                                    )) ) : ( <tr> <td colSpan={formik.values.type === "Mandal" ? 5 : 4} className="text-center"> No Data Available </td> </tr> )}
                            </tbody>
                       </Table>
                              </div>
                          </div>
                      </div>
                          </Modal.Body>
                      </Modal>
    </>
)}
 </div> </div>
            <AlertModal
                show={showAlert}
                titleText={alertData.titleText}
                alertText={alertData.alertText}
                onClose={closeAlert}
            /></div>
        </>
    );
};

export default DistrictIndicatorwiseperformanceMonitoringReport;
